const KEY = "alert_sound";

export const SOUND_OPTIONS = [
  { value: "none", label: "None (silent)" },
  { value: "ping", label: "Ping" },
  { value: "chime", label: "Chime" },
  { value: "blip", label: "Blip" },
];

export function getAlertSound() {
  try {
    return localStorage.getItem(KEY) || "ping";
  } catch {
    return "ping";
  }
}

export function setAlertSound(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch (err) {
    console.warn("Could not persist alert sound preference:", err);
  }
}

function tone(ctx, { freq, type = "sine", start = 0, duration = 0.18, gain = 0.12 }) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(gain, ctx.currentTime + start);
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + duration);
  osc.connect(g).connect(ctx.destination);
  osc.start(ctx.currentTime + start);
  osc.stop(ctx.currentTime + start + duration + 0.05);
}

export function playAlertSound(kind = getAlertSound()) {
  if (!kind || kind === "none") return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    if (kind === "ping") {
      tone(ctx, { freq: 880, duration: 0.22 });
    } else if (kind === "chime") {
      tone(ctx, { freq: 659.25, duration: 0.22 });
      tone(ctx, { freq: 987.77, start: 0.14, duration: 0.3 });
    } else if (kind === "blip") {
      tone(ctx, { freq: 520, type: "square", duration: 0.09, gain: 0.08 });
      tone(ctx, { freq: 780, type: "square", start: 0.1, duration: 0.09, gain: 0.08 });
    }
    setTimeout(() => ctx.close(), 1200);
  } catch (err) {
    console.debug("Alert sound unavailable:", err);
  }
}
